import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductConversionService {

  private url = environment.api + "api/erp/inventory/product-conversion";
  constructor(
    private http: HttpClient,
  ) { }

  getProductsConversion(warehouseId: number) {
    const params = new HttpParams()
      .set(
        'warehouse',
        warehouseId.toString()
      );
    return this.http.get(this.url, { params });
  }

  postCreateProductConversion(data: any) {
    return this.http.post(this.url, data);
  }

  getAllProductsConversion() {
    return this.http.get(this.url + `/all-product`);
  }

  getAllTargetProductByProductId(productId: any) {
    return this.http.get(this.url + `/products/${productId}`);
  }

  getAllProductByProductTarget(productTargetId: any) {
    return this.http.get(this.url + `/products-by-target/${productTargetId}`);
  }

  updateFactorProductConversionId(productConversionId: any, data: any) {
    return this.http.put(this.url + `/factors/${productConversionId}`, data);
  }

  deleteByProductConversionId(productConversionId: any) {
    return this.http.delete(this.url + `/${productConversionId}`);
  }

  deleteAllByProductId(productId: any) {
    return this.http.delete(this.url + `/products/${productId}`);
  }
}
